import React from 'react'
import classNames from 'classnames'
import ReactMarkdown from 'react-markdown'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import styles from './styles.css'

interface BodyProps {
  body: string
  bodyRichText?: string | null
  className?: string
}

const Body: React.SFC<BodyProps & WithAnalyticsProps> = ({ body, bodyRichText, className }) => {
  return (
    <div className={classNames(styles.body, className)}>
      {!bodyRichText && !body ? (
        <>
          Curated helps customers make the right purchasing decisions by connecting them to a team
          of industry experts. We focus on higher-cost products and travel categories that consumers
          traditionally find complicated to navigate, compare, or fully understand. By asking each
          customer a few simple questions, we are able to match them with the best expert to provide
          them with personalized recommendations.
        </>
      ) : bodyRichText ? (
        <ReactMarkdown source={bodyRichText} className={styles.richText} />
      ) : (
        body
      )}
    </div>
  )
}

export default withAnalytics(Body)
